import scheduleActionRequested from '../actions/scheduleActionRequested';
import { CALC_ENGINE_SCHEDULER_TIMEOUT } from '../utilities/constants';

const runners = {};

const dispatchAfterTimeout = (store) => (action, timeout) =>
  setTimeout(() => {
    store.dispatch(action);
  }, timeout);

const schedulerMiddleware = (store) => (next) => (action) => {
  next(action);

  const delayedDispatcher = dispatchAfterTimeout(store);

  if (
    action.type === scheduleActionRequested.type &&
    action.payload !== undefined &&
    action.payload.actionToSchedule !== undefined
  ) {
    const { actionToSchedule } = action.payload;
    const actionToScheduleType = actionToSchedule.type;

    const scheduledRunner = runners[actionToScheduleType];
    if (scheduledRunner) {
      clearTimeout(scheduledRunner);
    }

    runners[actionToScheduleType] = delayedDispatcher(
      actionToSchedule,
      CALC_ENGINE_SCHEDULER_TIMEOUT
    );
  }
};

export default schedulerMiddleware;
